import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { Category, CategoryEvents } from 'app/categories/category';

@Injectable({ providedIn: 'root' })
export class CategoryEventsService {
    catUrl = '';
    catEventsUrl = '';

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this.catUrl = baseUrl + 'api/Categories';
        this.catEventsUrl = baseUrl + 'api/CategoryEvents';
    }

    //#region Categories
    getCategories(): Observable<Category[]> {
        return this.http.get<Category[]>(this.catUrl);
    }

    getCategoryById(id: number): Observable<Category> {
        return this.http.get<Category>(`${this.catUrl}/${id}`);
    }

    createCategory(params: Category): Observable<Category> {
        return this.http.post<any>(this.catUrl, params);
    }

    updateCategory(id: number, category: Category): Observable<any> {
        return this.http.put(`${this.catUrl}/${id}`, category);
    }

    deleteCategory(id: number): Observable<Category> {
        return this.http.delete<Category>(`${this.catUrl}/${id}`);
    }
    //#endregion

    //#region CategoryEVents
    getCategoryEvents(): Observable<CategoryEvents[]> {
        return this.http.get<CategoryEvents[]>(this.catEventsUrl);
    }

    getCategoryEventsByEventId(id: number): Observable<CategoryEvents[]> {
        return this.http.get<CategoryEvents[]>(`${this.catEventsUrl}/ByEvent`, { params: { eventId: id.toString() } });
    }

    getCategoryEventById(id: number): Observable<CategoryEvents> {
        return this.http.get<CategoryEvents>(`${this.catEventsUrl}/${id}`);
    }

    createCategoryEvent(params: CategoryEvents): Observable<CategoryEvents> {
        return this.http.post<any>(this.catEventsUrl, params);
    }

    updateCategoryEvent(id: number, categoryEvents: CategoryEvents): Observable<any> {
        return this.http.put(`${this.catEventsUrl}/${id}`, categoryEvents);
    }

    deleteCategoryEvent(id: number): Observable<CategoryEvents> {
        return this.http.delete<CategoryEvents>(`${this.catEventsUrl}/${id}`);
    }
    //#endregion
}
